
import Config from "../constants/Configuration";
import IBotService from "../interfaces/IBotService";
import BotService from "./BotServices";
import MockBotService from "./MockBotService";

export class BotServiceFactory {
    static getBotService(useMockService: boolean): IBotService {
        if (useMockService) {
            return new MockBotService();
        } else {
            return new BotService(Config.ApiEndPoint);
        }
    }
}
